@if (!workspaceResolved()) {
  <app-loading-indicator>Loading contacts...</app-loading-indicator>
} @else if (!currentTeamWorkspace) {
  @for (item of items; track item.id; let index = $index) {
    <ng-container [ngTemplateOutlet]="navigationItem" [ngTemplateOutletContext]="{ item, index, tenant: undefined }" />
  }
  <app-sidebar-items-divider />
  <app-side-bar-groups (selectFilter)="selectFilter($event)" [team]="undefined" />
  <app-sidebar-items-divider />
  <!-- Personal workspace: Pinned Knots · Pinned Tags · Pinned Connections, as Notes (Johanna, 2026-10-21). -->
  <app-knowledge-items-rail [sidebarSplitViewKey]="SidebarSplitViewKey.contacts" [tenantId]="currentTeamId" [team]="undefined" />
} @else {
  @if (currentMemberTenant) {
    <section class="rail-section">
      <button
        type="button"
        class="rail-section-heading"
        [attr.aria-expanded]="myWorkspaceExpanded()"
        (click)="myWorkspaceExpanded.set(!myWorkspaceExpanded())"
      >
        <app-icon name="sapphire-chevron-right" size="s" [class.rotate-90]="myWorkspaceExpanded()" />My Workspace
      </button>
      @if (myWorkspaceExpanded()) {
        <div class="rail-section-content">
          <ng-container
            [ngTemplateOutlet]="sectionContent"
            [ngTemplateOutletContext]="{ tenant: currentMemberTenant, more: moreExpanded }"
          />
        </div>
      }
    </section>
  }
  <app-sidebar-shared-placeholder [headerTemplate]="currentMemberTenant ? contactsSharedHeader : undefined" />
  <section class="rail-section">
    <button
      type="button"
      class="rail-section-heading"
      [attr.aria-expanded]="teamWorkspaceExpanded()"
      (click)="teamWorkspaceExpanded.set(!teamWorkspaceExpanded())"
    >
      <app-icon name="sapphire-chevron-right" size="s" [class.rotate-90]="teamWorkspaceExpanded()" />Team Workspace
    </button>
    @if (teamWorkspaceExpanded()) {
      <div class="rail-section-content">
        <button
          type="button"
          class="rail-workspace-row"
          [attr.aria-expanded]="currentTeamWorkspaceExpanded()"
          (click)="currentTeamWorkspaceExpanded.set(!currentTeamWorkspaceExpanded())"
        >
          <app-icon name="sapphire-chevron-right" size="s" [class.rotate-90]="currentTeamWorkspaceExpanded()" />
          <span
            class="rail-workspace-avatar"
            [style.background-color]="workspaceColor(currentTeamWorkspace)"
            [style.color]="currentTeamWorkspace.color ? null : workspacePalette(currentTeamWorkspace).text"
            >{{ currentTeamWorkspaceInitials }}</span
          >
          <span class="rail-workspace-title">{{ currentTeamWorkspace.title }}</span>
        </button>
        @if (currentTeamWorkspaceExpanded()) {
          <div class="rail-team-workspace-content">
            <ng-container
              [ngTemplateOutlet]="sectionContent"
              [ngTemplateOutletContext]="{ tenant: currentTeamTenant, more: teamMoreExpanded }"
            />
          </div>
        }
      </div>
    }
  </section>
}

<ng-template #sectionContent let-tenant="tenant" let-more="more">
  @if (advancedSearchApplied && currentTeamId === tenant.id) {
    <ng-container
      [ngTemplateOutlet]="navigationItem"
      [ngTemplateOutletContext]="{ item: searchResultsItem, index: 0, tenant }"
    />
  }
  @for (item of tenant === currentMemberTenant ? myPrimaryItems : primaryItems; track item.id; let index = $index) {
    <ng-container [ngTemplateOutlet]="navigationItem" [ngTemplateOutletContext]="{ item, index, tenant }" />
  }
  <button type="button" class="rail-view-more" [attr.aria-expanded]="more()" (click)="more.set(!more())">
    <app-icon name="sapphire-chevron-right" size="s" [class.rotate-90]="more()" />View more
  </button>
  @if (more()) {
    @for (item of moreItems; track item.id; let index = $index) {
      <ng-container
        [ngTemplateOutlet]="navigationItem"
        [ngTemplateOutletContext]="{ item, index: index + primaryItems.length, tenant }"
      />
      @if (item.id === 'snoozed') {
        @if (tenant.id === currentTeamTenant?.id) {
          <app-sidebar-item data-filter="following" [attr.data-tenant]="tenant.id" [title]="'Following'" icon="bell" [depth]="0"
            [active]="currentTeamId === tenant.id && sidebarFilter === 'following'"
            (appClick)="selectFilter('following', tenant)"
            [appSidebarContextMenu]="'following'" [appSidebarContextMenuTenantId]="tenant.id"
            [appSidebarContextMenuRail]="true" appSidebarContextMenuRailScope="team" />
        } @else {
          <app-sidebar-item data-filter="following" [attr.data-tenant]="tenant.id" [title]="'Following'" icon="bell" [comingSoon]="true" [depth]="0"
            appSidebarContextMenu="following" [appSidebarContextMenuTenantId]="tenant.id"
            [appSidebarContextMenuRail]="true" appSidebarContextMenuRailScope="mine" />
        }
      }
    }
  }
  <div class="rail-item-divider"></div>
  <app-side-bar-groups
    [title]="tenant.id === currentTeamTenant?.id ? 'Team Groups' : 'Groups'"
    [depth]="0"
    [tenantId]="tenant.id"
    [team]="tenant"
    [rail]="true"
    [railScope]="tenant === currentTeamTenant ? 'team' : 'mine'"
    (selectFilter)="selectFilter($event, tenant)"
  />
  <div class="rail-item-divider"></div>
  <app-knowledge-items-rail
    [sidebarSplitViewKey]="SidebarSplitViewKey.contacts"
    [tenantId]="tenant.id"
    [team]="tenant"
    [knotsTitle]="tenant.id === currentMemberTenant?.id ? 'Pinned Knots' : 'Team Knots'"
    [tagsTitle]="tenant.id === currentMemberTenant?.id ? 'Pinned Tags' : 'Team Tags'"
    [rowHeight]="32"
    [knotsRailEntries]="tenant === currentTeamTenant ? pinnedMenus.team.knots : pinnedMenus.mine.knots"
    [tagsRailEntries]="tenant === currentTeamTenant ? pinnedMenus.team.tags : pinnedMenus.mine.tags"
    [knotsManageLabel]="tenant === currentTeamTenant ? 'Manage Team Knots' : 'Manage Pinned Knots'"
    [tagsManageLabel]="tenant === currentTeamTenant ? 'Manage Team Tags' : 'Manage Pinned Tags'"
  />
</ng-template>

<ng-template #navigationItem let-item="item" let-index="index" let-tenant="tenant">
  <app-sidebar-item
    class="rail-navigation-item rounded [&:not(.drag-over)]:hover:bg-hover"
    [attr.data-tenant]="tenant?.id || 'personal'"
    [attr.data-filter]="item.id"
    [title]="item.title"
    [icon]="item.icon"
    [depth]="0"
    [active]="currentTeamId === tenant?.id && sidebarFilter === item.id"
    (appClick)="selectFilter(item.id, tenant)"
    [appSidebarContextMenu]="item.id"
    [stchPopoverDisabled]="item.id === searchResultsItem.id"
    [appSidebarContextMenuTenantId]="tenant?.id"
    [appSidebarContextMenuRail]="
      !!tenant && (tenant === currentMemberTenant || tenant === currentTeamTenant) && item.id !== searchResultsItem.id
    "
    [appSidebarContextMenuRailScope]="tenant === currentTeamTenant ? 'team' : 'mine'"
    #elRef
    appDroppable
    [appDroppableDisabled]="item.id === searchResultsItem.id"
    appDroppableHoverClass="drag-over"
    [appDroppablePredicate]="dndPredicate"
    (appDroppableDrop)="dndDropOnRow($event, item.id, elRef, tenant)"
  />
</ng-template>

<!--
  The Shared header with a menu. Shared sits outside My Workspace's section, but it is the member's: its
  menu names the member workspace, never the team the rail happens to show. A right-click opens the menu
  and does not toggle the section; a click toggles it exactly as the default header does.
-->
<ng-template #contactsSharedHeader let-expanded="expanded" let-toggle="toggle">
  <button
    type="button"
    class="shared-placeholder-header"
    [attr.aria-expanded]="expanded"
    (click)="toggle()"
    appSidebarContextMenu="shared"
    [appSidebarContextMenuTenantId]="currentMemberTenant?.id"
    [appSidebarContextMenuRail]="true"
    appSidebarContextMenuRailScope="mine"
  >
    <app-icon name="sapphire-chevron-right" size="s" [class.rotate-90]="expanded" />
    Shared
  </button>
</ng-template>

<ng-template #afterDropTemplate let-item="item">
  <app-contact-quick-form
    [autofocus]="true"
    [showMore]="true"
    [title]="item.title"
    [contact]="item"
    (more)="handleMore($event)"
    (close)="handleClose()"
    [transferredDraft]="true"
  />
</ng-template>
